import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message, (field, i) => {
    return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentForField(field)), {
      key: i + field.fieldType,
      field: field,
      keyMapper: _ctx.keyMapper
    }, null, 8, ["field", "keyMapper"]))
  }), 128))
}